import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14e9f0bf")

_pushScopeId("data-v-14e9f0bf")
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "flex_centers" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.tabs, (l, i) => {
        return (_openBlock(), _createBlock("li", {
          key: i,
          onClick: ($event: any) => ($setup.toggleTab(i))
        }, _toDisplayString(l), 9, ["onClick"]))
      }), 128)),
      _createVNode("div", {
        class: ['tab_active', { 'selected-second': $props.tabIdx === 1 }]
      }, null, 2)
    ])
  ]))
})